import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Library from "@/pages/Library";
import Studio from "@/pages/Studio";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import BillingReturn from "@/pages/BillingReturn";
import MockCheckout from "@/pages/MockCheckout";
import Listen from "@/pages/Listen";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminCodes from "@/pages/AdminCodes";
import { AuthProvider, useAuth } from "@/lib/auth";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#080708]" data-testid="auth-checking" />;
  return user ? children : <Navigate to="/login" replace />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/library" element={<Protected><Library /></Protected>} />
      <Route path="/studio/:id" element={<Studio />} />
      <Route path="/billing/return" element={<Protected><BillingReturn /></Protected>} />
      <Route path="/billing/mock-checkout" element={<Protected><MockCheckout /></Protected>} />
      <Route path="/checkout" element={<Protected><Checkout /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Navigate to="/checkout" replace />} />
      <Route path="/admin/codes" element={<Protected><AdminCodes /></Protected>} />
      <Route path="/listen/:shareId" element={<Listen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: { background: "#1c1822", border: "1px solid #5a1e28", color: "#F5F2EB", borderRadius: 2 },
        }}
      />
    </div>
  );
}

export default App;
